<template>
	<div class="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mt-4">
		<div class="flex flex-wrap items-center gap-1">
			<!-- Primeira -->
			<button
				class="pagination-button"
				:disabled="currentPage === 1"
				@click="setPage(1)"
			>
				Primeira
			</button>

			<!-- Anterior -->
			<button
				class="pagination-button"
				:disabled="currentPage === 1"
				@click="setPage(currentPage - 1)"
			>
				&lt;
			</button>

			<!-- Páginas com reticências -->
			<button
				v-for="page in getPaginationPages()"
				:key="page.key"
				@click="setPage(page.number)"
				:disabled="page.ellipsis"
				:class="[
					'pagination-button',
					{ 'bg-green-500 text-white': page.number === currentPage }
				]"
			>
				{{ page.ellipsis ? '…' : page.number }}
			</button>

			<!-- Próxima -->
			<button
				class="pagination-button"
				:disabled="currentPage === totalPages"
				@click="setPage(currentPage + 1)"
			>
				&gt;
			</button>

			<!-- Última -->
			<button
				class="pagination-button"
				:disabled="currentPage === totalPages"
				@click="setPage(totalPages)"
			>
				Última
			</button>
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';

export default {
	props: {
		total: Number,
		limit: Number,
		modelValue: Number
	},
	emits: ['update:modelValue', 'changePage'],
	setup(props, { emit }) {
		const totalPages = computed(() => Math.ceil(props.total / props.limit));
		const currentPage = computed(() => props.modelValue);
		const from = computed(() => (currentPage.value - 1) * props.limit + 1);
		const to = computed(() => Math.min(props.total, currentPage.value * props.limit));

		function setPage(page) {
			if (page >= 1 && page <= totalPages.value) {
				emit('update:modelValue', page);
				emit('changePage', page);
			}
		}

		function getPaginationPages() {
			const pages = [];
			const maxVisible = 5;
			const half = Math.floor(maxVisible / 2);

			let start = Math.max(2, currentPage.value - half);
			let end = Math.min(totalPages.value - 1, currentPage.value + half);

			if (currentPage.value <= half + 1) {
				start = 2;
				end = Math.min(totalPages.value - 1, maxVisible);
			} else if (currentPage.value >= totalPages.value - half) {
				start = Math.max(2, totalPages.value - maxVisible + 1);
				end = totalPages.value - 1;
			}

			pages.push({ number: 1, key: 'page-1' });

			if (start > 2) {
				pages.push({ number: '...', key: 'start-ellipsis', ellipsis: true });
			}

			for (let i = start; i <= end; i++) {
				pages.push({ number: i, key: `page-${i}` });
			}

			if (end < totalPages.value - 1) {
				pages.push({ number: '...', key: 'end-ellipsis', ellipsis: true });
			}

			if (totalPages.value > 1) {
				pages.push({ number: totalPages.value, key: `page-${totalPages.value}` });
			}

			return pages;
		}

		return {
			currentPage,
			from,
			to,
			totalPages,
			setPage,
			getPaginationPages
		};
	}
};
</script>
